import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    padding: 0,

    '& .slot-details': {
      '&-content': {
        padding: 0,
        maxHeight: theme.spacing(53),
      },
      '&-header': {
        display: 'flex',
        padding: theme.spacing(6, 3, 3),

        '&-icon': {
          color: theme.palette.primary.main,
          fontSize: theme.spacing(6),
          marginRight: theme.spacing(2),
        },
        '&-infos': {
          flexDirection: 'column',
          flexGrow: 1,
        },
        '&-label': {
          color: theme.palette.text.hint,
        },
      },
    },

    '& .list-professionals-title': {
      padding: theme.spacing(3),
      color: theme.palette.text.hint,
      position: 'sticky',
      top: 0,
      background: theme.palette.custom.background.area,
      display: 'flex',
      zIndex: '1',
    },

    '& .item': {
      '&-avatar': {
        '&-container': {
          background: theme.palette.custom.surface[1],
          color: theme.palette.text.secondary,
        },
      },
      '&-text': {
        '&-container': {
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
        },
        '&-area': {
          color: theme.palette.text.hint,
        },
      },
      '&-vacancies': {
        background: theme.palette.custom.surface[3],
        color: theme.palette.text.hint,
        display: 'flex',
        alignItems: 'center',
        height: theme.spacing(3),
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(0, 1),
        lineHeight: 1,
        margin: theme.spacing(0, 2),
      },
      '&-icon-go': {
        color: theme.palette.text.hint,
      },
    },
  },
  paper: {
    width: '100%',
  },
}));

export default styles;
